<template>
  <Container type="card-full" drankColor>
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">协议编号</div>
          <div class="field">
            <el-input v-model.trim="query.ptccode" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type="primary" @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols"
            :showfooter="false" :showPage="false" :resizable="true" :defaultPage="10" @cellDblClick="viewProject"
            :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
    
    <el-dialog
        title="修改协议状态"
        :visible.sync="dialogchangeStatus"
        width="50%"
    >
      <div class="row">
        <div class="col">
          <div class="lab">协议编号：</div>
          <div class="val">{{p_obj.code}}</div>
        </div>
        <div class="col">
          <div class="lab">协议名称：</div>
          <div class="val">{{p_obj.title}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="lab">协议状态：</div>
          <div class="val">
            <el-select v-model="p_obj.ptcstatus" :clearable="true" placeholder="请选择">
                <el-option
                    v-for="item in ptc_Status"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="lab"></div>
          <div class="val">
            <el-button type='primary' round @click="savePtcInfo">保存</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  export default {
    name: 'changeStatus',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        dialogchangeStatus: false,
        btn:{},
        btnClone:{},
        btnLoading: false,
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 50 },
          { field: 'code', fieldtype: 'C', title: '项目/协议编号',calculExpr:'',addNewRowFlg: false},
          { field: 'title', fieldtype: 'C', title: '项目/协议名称',calculExpr:'',addNewRowFlg: false},
          { field: 'time', fieldtype: 'T', title: '创建时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', 'yyyy-MM-dd']}
        ],
        // 0起草中，1已提交，2已完成，3已终止
        ptc_Status: [
            {value:0,label:'起草中'},
            {value:1,label:'已提交'},
            {value:2,label:'已完成'},
            {value:3,label:'已终止'}
        ],
        p_obj: {},
        projectStatusList: [],
        query: {
          cosid: this.$store.getters.loginUser.cosid
        }
      }
    },
    created () {
      this.$on('CHG', () => this.chgProject())
    },
    activated() {
      this.init()
      this.getProjectStatusList()
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      async getProjectStatusList () {
        this.projectStatusList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'projectstatus'}
        })
      },
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.p_obj = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
        this.btnClone = _.cloneDeep(btn)
      },
      async init() {
        // this.list = []
        this.btnLoading = false
        this.p_obj = {}
      },
      async viewProject(row) {
        this.p_obj = row.row
        if(this.p_obj.projectid){
            this.$router.push({name: 'changeStatusFrom', params: {projectid: this.p_obj.projectid}})
        }
        else{
          this.dialogchangeStatus = true
        }
      },
      async cellClick (row) {
        this.p_obj = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async chgProject () {
        if (!this.p_obj.projectid && !this.p_obj.ptcid) {
          this.$message.warning('请选择一个项目!')
          return
        }
        if(this.p_obj.projectid){
            this.$router.push({name: 'changeStatusFrom', params: {projectid: this.p_obj.projectid}})
        } else {
          this.dialogchangeStatus = true
        }
      },
      async getPageList () {
        this.loading = true
        this.query.cosid = this.$store.getters.loginUser.cosid

        let res = await request({
          method: 'get',
          url: '/xtgl/status/getList',
          params: this.query
        })
        if(res.issuccess === 1){
          this.list = res.data
        } else {
          this.$message.warning(res.msg)
        }
        this.query.total = 1
        this.loading = false
      },
      async savePtcInfo() {
        let res = await request({
          method: 'post',
          url: '/xtgl/status/savePtcInfo',
          data: this.p_obj
        })

        if(+res.issuccess === 1) {
          this.$message.success(res.msg)
          this.dialogchangeStatus = false
        }

      }
    }
  }
</script>
<style lang="scss" scoped>
.row{
  display: flex;
  margin: 20px 0;
  line-height: 40px;
  .col{
    display: flex;
    .lab{
      width: 85px;
      text-align: right;
    }
    .val{
      margin-right: 20px;
    }
  }
}
</style>
